import AddIcon from '@mui/icons-material/Add';
import { Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { addCareerBuilderEdge } from 'wisestep-api';
import { ArrowButton, WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import CareerBuilder from '../../../../../images/jobBoardsIcons/CareerBuilder.png';
import { warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import NativeSearchSettings from '../../../NativeSearchSettings';
import { NativeDialogHeader } from '../dice/DiceNewAccount';

const CareerBuilderEdgeNewAccount = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const navigate = useNavigate();
  const onClickHandler = async () => {
    try {
      const response = await addCareerBuilderEdge();
      window.location.href = response.data.url;
      console.log('CBRE');
    } catch (error) {
      setNotification(warning('Something went wrong, Please try again.'));
    }
  };
  return (
    <NativeSearchSettings>
      <Box>
        <NativeDialogHeader>
          <Grid item xs={12} container justifyContent="flex-start" columnGap={2}>
            <ArrowButton title="" onClick={() => navigate('/native-search-settings/cb-edge')} />
            <img src={CareerBuilder} alt="CareerBuilder" height="35" />
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>
              Add new Career Builder Edge account
            </WsTypography>
          </Grid>
        </NativeDialogHeader>
        <Box bgcolor="white">
          <Grid container p={4} rowGap={3}>
            <Grid item xs={12}>
              <WsTypography>
                Configure your Career Builder Edge account using search credentials.
              </WsTypography>
            </Grid>
            <Grid item xs={12}>
              <WsButton
                startIcon={<AddIcon fontSize="small" />}
                size="large"
                onClick={() => onClickHandler()}
              >
                Add account
              </WsButton>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </NativeSearchSettings>
  );
};

export default CareerBuilderEdgeNewAccount;
